import React from 'react'
import { BrowserRouter } from 'react-router-dom'

import AuthContextProvider from './contexts/AuthContextProvider'
import './App.less'

import Router from './route'

const App = () => {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthContextProvider>
        <Router></Router>
      </AuthContextProvider>
    </BrowserRouter>
  )
}

export default App
